import MUIDataTable from "mui-datatables";
import * as React from 'react'
import { unstable_batchedUpdates } from 'react-dom'
import api from '../services/api'
import './style.css'
import { Badge, Box, Container, IconButton, ThemeProvider, Tooltip, CircularProgress } from "@mui/material";
import theme from "../themeDash";
import { grey, lightBlue, purple, red, teal } from "@mui/material/colors";
import { yellow } from "@mui/material/colors";
import { blueGrey } from "@mui/material/colors";
import { orange } from "@mui/material/colors";
import { lime } from "@mui/material/colors";
import moment from "moment";
import 'moment/locale/pt-br'
import ButtonsDash from "./Buttons-dash";
import { Button } from "@mui/material";
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import { green } from "@mui/material/colors";
import { Typography } from "@mui/material";
import FormDialog from "./FormDialog";
import MapIcon from '@mui/icons-material/Map';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import { useAuth } from '../auth/AuthProvider'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { useNavigate } from "react-router-dom";
import AutorenewIcon from '@mui/icons-material/Autorenew';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import FormDialogHistory from './FormDialogHistory'
import FormDialogEmpresa from '../Empresa/FormDialog'
import NotifyOptionsProvider from './Notify'
import GraphDialog from "./GraphDialog";
import { pink } from "@mui/material/colors";
import ShowChartIcon from '@mui/icons-material/ShowChart';
import ArticleIcon from '@mui/icons-material/Article';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import FormDialogPPI from './FormDialogPPI'
import ApiDownBanner from './ApiDownBanner'
import { Alert, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, List, ListItemButton, ListItemText, Select, MenuItem as SelectItem, Snackbar, TextField } from "@mui/material";
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PerfOverlay from '../components/PerfOverlay';

// Phase 3a: Cache de moment() para evitar recalculos
const formatClockCache = new Map()
function formatClock(clock) {
  const key = clock
  if (formatClockCache.has(key)) return formatClockCache.get(key)
  const result = moment(clock).locale('pt-br').format('DD/MM HH:mm')
  formatClockCache.set(key, result)
  return result
}

let fromNowEpoch = 0
const fromNowCache = new Map()
function fromNowClock(clock, epoch) {
  if (epoch !== fromNowEpoch) {
    fromNowCache.clear()
    fromNowEpoch = epoch
  }
  const key = clock
  if (fromNowCache.has(key)) return fromNowCache.get(key)
  const result = moment(clock).locale('pt-br').fromNow()
  fromNowCache.set(key, result)
  return result
}

const MAX_ANIMATION_IDS = 20;


export default function () {
  const [problems, setProblems] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const [totalCount, setTotalCount] = React.useState(0)
  const [page, setPage] = React.useState(0)

  // IDs para animacao (novos aparecem com fade-in, removidos com fade-out)
  const [newAlarmIds, setNewAlarmIds] = React.useState(new Set())
  const [resolvingIds, setResolvingIds] = React.useState(new Set())
  const [rowsPerPage, setRowsPerPage] = React.useState(() => {
    const saved = localStorage.getItem('Page')
    return saved ? JSON.parse(saved) : 100
  })

  // Carrega filtros salvos do localStorage (apenas na inicializacao)
  const initialFilters = React.useRef(null)
  if (initialFilters.current === null) {
    try {
      const saved = localStorage.getItem('alarmFilters')
      const parsed = saved ? JSON.parse(saved) : {}
      // Garante que arrays de numeros sao numeros (nao strings)
      initialFilters.current = {
        search: parsed.search || '',
        cod_empresa: (parsed.cod_empresa || []).map(Number),
        severity: (parsed.severity || []).map(Number),
        acks: (parsed.acks || []).map(Number),
        source: parsed.source || '',
        zabbix_severity: (parsed.zabbix_severity || []).map(Number),
        wazuh_severity: (parsed.wazuh_severity || []).map(Number),
      }
    } catch {
      initialFilters.current = { search: '', cod_empresa: [], severity: [], acks: [], source: '', zabbix_severity: [], wazuh_severity: [] }
    }
  }

  // Estados para filtros server-side
  const [searchText, setSearchText] = React.useState(initialFilters.current.search)
  const [filterEmpresa, setFilterEmpresa] = React.useState(initialFilters.current.cod_empresa)
  const [filterSeverity, setFilterSeverity] = React.useState(initialFilters.current.severity)
  const [filterAcks, setFilterAcks] = React.useState(initialFilters.current.acks)
  const [filterSource, setFilterSource] = React.useState(initialFilters.current.source)
  const [filterZabbixSeverity, setFilterZabbixSeverity] = React.useState(initialFilters.current.zabbix_severity)
  const [filterWazuhSeverity, setFilterWazuhSeverity] = React.useState(initialFilters.current.wazuh_severity)
  const [sortColumn, setSortColumn] = React.useState('clock')
  const [sortDirection, setSortDirection] = React.useState('desc')
  const searchTimeoutRef = React.useRef(null)

  // Salva filtros no localStorage quando mudam (para notificacoes)
  const isFirstRender = React.useRef(true)
  React.useEffect(() => {
    // Pula primeira renderizacao para nao sobrescrever valores carregados
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    localStorage.setItem('alarmFilters', JSON.stringify({
      search: searchText,
      cod_empresa: filterEmpresa,
      severity: filterSeverity,
      acks: filterAcks,
      source: filterSource,
      zabbix_severity: filterZabbixSeverity,
      wazuh_severity: filterWazuhSeverity,
    }))
  }, [searchText, filterEmpresa, filterSeverity, filterAcks, filterSource, filterZabbixSeverity, filterWazuhSeverity])

  const [handlerDialog, setHandlerDialog] = React.useState(false)
  const [handlerDialogHistory, setHandlerDialogHistory] = React.useState(false)

  const [handlerDialogEmpresa, setHandlerDialogEmpresa] = React.useState(false)
  const [handlerDialogPPI, sethandlerDialogPPI] = React.useState(false)
  const [handlerGraph, setHandlerGraph] = React.useState(false)
  const [severity, setSeverity] = React.useState(false)
  const [hostid, setHostid] = React.useState('')
  const [codEmpresa, setCodEmpresa] = React.useState('')
  const [tags, setTags] = React.useState('')
  const [ppi, setPpi] = React.useState('')
  const [historyInfo, setHistoryInfo] = React.useState({})
  const [eventId, setEventId] = React.useState('')
  const [itemid, setItemid] = React.useState('')
  const [update, setUpdate] = React.useState('')
  const [detailAlarms, setDetailAlarms] = React.useState('')
  const [alarmSource, setAlarmSource] = React.useState('zabbix')
  const [alarmHostname, setAlarmHostname] = React.useState('')
  const [alarmIp, setAlarmIp] = React.useState('')
  const [alarmClock, setAlarmClock] = React.useState('')
  const [alarmOccurrences, setAlarmOccurrences] = React.useState(1)
  const [alarmTagsPpi, setAlarmTagsPpi] = React.useState(0)
  const [bulkAlarms, setBulkAlarms] = React.useState([])
  const selectedAlarmIds = React.useRef(new Set())

  const [mapPickerData, setMapPickerData] = React.useState({ open: false, maps: [], cod: null, hid: null })
  const [athenaTicketOpen, setAthenaTicketOpen] = React.useState(false)
  const [athenaTicket, setAthenaTicket] = React.useState({ subject: '', description: '' })
  const [athenaDefaultConfig, setAthenaDefaultConfig] = React.useState(null)
  const [athenaLoading, setAthenaLoading] = React.useState(false)
  const [athenaSnack, setAthenaSnack] = React.useState({ open: false, message: '', severity: 'success' })
  const [id, setId] = React.useState()
  const auth = useAuth()
  const [empresas, setEmpresas] = React.useState([])
  const navigate = useNavigate()

  const [dismissSnack, setDismissSnack] = React.useState({ open: false, message: '', severity: 'success' })
  const [viewingMap, setViewingMap] = React.useState({})

  // Phase 3a: epoch counter para invalidar cache de fromNow (incrementado a cada 60s)
  const [timeEpoch, setTimeEpoch] = React.useState(0)

  // Phase 6: filtersRef para estabilizar event listeners
  const filtersRef = React.useRef({
    page: 0, rowsPerPage: 100, filterEmpresa: [], filterSeverity: [],
    filterAcks: [], filterSource: '', filterZabbixSeverity: [],
    filterWazuhSeverity: [], searchText: '', sortColumn: 'clock',
    sortDirection: 'desc',
  })
  // Manter filtersRef sincronizado
  React.useEffect(() => {
    filtersRef.current = {
      page, rowsPerPage, filterEmpresa, filterSeverity, filterAcks,
      filterSource, filterZabbixSeverity, filterWazuhSeverity, searchText,
      sortColumn, sortDirection,
    }
  }, [page, rowsPerPage, filterEmpresa, filterSeverity, filterAcks, filterSource, filterZabbixSeverity, filterWazuhSeverity, searchText, sortColumn, sortDirection])

  // Phase 7: rastrear ultimo evento WS processado
  const lastWsUpdate = React.useRef(0)

  // Phase 5: timer ref unico para limpeza de animacoes
  const animationTimerRef = React.useRef(null)

  // PerfOverlay: render counter + show flag
  const renderCountRef = React.useRef(0)
  renderCountRef.current++
  const showPerf = process.env.NODE_ENV === 'development' || new URLSearchParams(window.location.search).has('perf')

  // Refs para desacoplar columns/options de state volatil (evita re-render do MUIDataTable)
  const problemsRef = React.useRef(problems)
  React.useEffect(() => { problemsRef.current = problems }, [problems])

  const viewingMapRef = React.useRef(viewingMap)
  React.useEffect(() => { viewingMapRef.current = viewingMap }, [viewingMap])

  const newAlarmIdsRef = React.useRef(newAlarmIds)
  React.useEffect(() => { newAlarmIdsRef.current = newAlarmIds }, [newAlarmIds])

  const resolvingIdsRef = React.useRef(resolvingIds)
  React.useEffect(() => { resolvingIdsRef.current = resolvingIds }, [resolvingIds])

  const handleDismiss = (cod_empresa, event_id) => {
    if (!window.confirm('Dispensar este alarme do painel ativo?')) return
    api.post('/webhooks/dismiss', { cod_empresa, event_id })
      .then(() => {
        setProblems(prev => prev.filter(p => !(p.cod_empresa === cod_empresa && p.event_id === event_id)))
        setTotalCount(prev => Math.max(0, prev - 1))
        setDismissSnack({ open: true, message: 'Alarme dispensado', severity: 'success' })
      })
      .catch((err) => {
        const msg = err.response?.status === 422
          ? err.response.data.detail
          : 'Erro ao dispensar alarme'
        setDismissSnack({ open: true, message: msg, severity: 'warning' })
      })
  }

  const getEmpresas = () => api.get('/empresa/all').then(res => setEmpresas(res.data.filter(empresa => empresa.status == 1).map(empresa => empresa.cod_empresa)))

  const openAckDialog = (problem) => {
    setId(problem.event_id)
    setHostid(problem.hostid)
    setTags(problem.tags)
    setSeverity(problem.severity)
    setCodEmpresa(problem.cod_empresa)
    setEventId(problem.event_id)
    setDetailAlarms(`${problem.hostname || ''} - ${problem.name || ''}`)
    setAlarmSource(problem.source || 'zabbix')
    setAlarmHostname(problem.hostname || '')
    setAlarmIp(problem.ip || '')
    setAlarmClock(problem.clock || '')
    setAlarmOccurrences(problem.occurrence_count || 1)
    setAlarmTagsPpi(problem.tags_ppi || 0)
    setHandlerDialog(true)
  }

  const openAthenaTicket = () => {
    api.get('/dashboard/athena-config/0').then(res => {
      if (!res.data || res.data.length === 0) {
        alert('Configure uma instancia Athena default (cod_empresa=0) antes de criar ticket avulso')
        return
      }
      setAthenaDefaultConfig(res.data[0])
      setAthenaTicket({ subject: '', description: '' })
      setAthenaTicketOpen(true)
    }).catch(() => alert('Erro ao buscar config Athena default'))
  }

  const submitAthenaTicket = () => {
    if (!athenaDefaultConfig || !athenaTicket.subject || !athenaTicket.description) return
    setAthenaLoading(true)
    api.post('/dashboard/ticket/athena/', {
      config_id: athenaDefaultConfig.id,
      subject: athenaTicket.subject,
      description: athenaTicket.description,
    })
      .then(() => {
        setAthenaSnack({ open: true, message: 'Ticket criado com sucesso!', severity: 'success' })
        setAthenaTicketOpen(false)
      })
      .catch(() => {
        setAthenaSnack({ open: true, message: 'Erro ao criar ticket', severity: 'error' })
      })
      .finally(() => setAthenaLoading(false))
  }

  const getProblems = React.useCallback((
    currentPage = page,
    currentRowsPerPage = rowsPerPage,
    search = searchText,
    empresaFilter = filterEmpresa,
    severityFilter = filterSeverity,
    acksFilter = filterAcks,
    sortCol = sortColumn,
    sortDir = sortDirection,
    sourceFilter = filterSource,
    zabbixSevFilter = filterZabbixSeverity,
    wazuhSevFilter = filterWazuhSeverity
  ) => {
    setLoading(true)

    // Monta query params
    const params = new URLSearchParams()
    params.append('page', currentPage + 1)
    params.append('per_page', currentRowsPerPage)

    if (search) params.append('search', search)
    if (empresaFilter.length > 0) params.append('cod_empresa', empresaFilter.join(','))
    if (severityFilter.length > 0) params.append('severity', severityFilter.join(','))
    if (acksFilter.length > 0) params.append('acks', acksFilter.join(','))
    if (sortCol) params.append('sort_column', sortCol)
    if (sortDir) params.append('sort_direction', sortDir)
    if (sourceFilter) params.append('source', sourceFilter)
    if (zabbixSevFilter.length > 0) params.append('zabbix_severity', zabbixSevFilter.join(','))
    if (wazuhSevFilter.length > 0) params.append('wazuh_severity', wazuhSevFilter.join(','))

    api.get(`/dashboard/problems/?${params.toString()}`)
      .then(res => {
        if (res.data.items) {
          setProblems(res.data.items)
          setTotalCount(res.data.total)
        } else {
          setProblems(res.data)
          setTotalCount(res.data.length)
        }
      })
      .catch((err) => {
        if (err.response?.status == 401) {
          navigate('/401')
        }
        setProblems([])
      })
      .finally(() => setLoading(false))
  }, [page, rowsPerPage, searchText, filterEmpresa, filterSeverity, filterAcks, sortColumn, sortDirection, filterSource, filterZabbixSeverity, filterWazuhSeverity, navigate])

  const columns = React.useMemo(() => [
    {
      name: "event_id",
      label: "Evento ID",
      options: {
        filter: false,
        sort: false,
        display: false,
      }
    },
    {
      name: "cod_empresa",
      label: "Alarme",
      options: {
        filter: true,
        sort: true,
        display: true,
        filterList: filterEmpresa,
        customFilterListOptions: { render: v => `Empresa: ${v}` },
        filterOptions: {
          names: [...new Set([...filterEmpresa, ...empresas])].sort((a, b) => a - b),
        },
        customBodyRenderLite: (dataIndex) => {
          const problem = problemsRef.current[dataIndex]
          if (!problem) return null
          const viewers = viewingMapRef.current[`${problem.cod_empresa}:${problem.event_id}`]
          return (
            <Box sx={{ py: 0 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  {!filterSource && <Typography fontSize={11} fontWeight="bold" sx={{
                    px: 0.6, py: 0.1, borderRadius: 1, lineHeight: 1.4,
                    color: '#fff',
                    backgroundColor: (problem.source || 'zabbix') === 'wazuh' ? purple[400] : teal[600],
                  }}>{(problem.source || 'zabbix') === 'wazuh' ? 'W' : 'Z'}</Typography>}
                  <Typography fontSize={14} fontWeight="bold">{problem.cod_empresa}</Typography>
                  <Typography fontSize={14}>-</Typography>
                  <Typography fontSize={14} fontWeight="bold">{problem.hostname}</Typography>
                  {problem.ip && <Typography fontSize={14} sx={{ opacity: 0.85 }}>({problem.ip})</Typography>}
                  {problem.occurrence_count > 1 && <Badge badgeContent={problem.occurrence_count} color="warning" max={9999} sx={{ ml: 2, mr: 1 }} />}
                  {problem.escalation_count > 0 && (
                    <Tooltip title="Acionamentos realizados">
                      <Badge badgeContent={problem.escalation_count} max={99}
                        sx={{ ml: 1.5, '& .MuiBadge-badge': { backgroundColor: lightBlue[600], color: '#fff', fontSize: 11, minWidth: 18, height: 18 } }}>
                        <ContactPhoneIcon sx={{ fontSize: 18, color: lightBlue[800], opacity: 0.9 }} />
                      </Badge>
                    </Tooltip>
                  )}
                  {problem.ppi_execution_count > 0 && (
                    <Tooltip title="Procedimentos executados">
                      <Badge badgeContent={problem.ppi_execution_count} max={99}
                        sx={{ ml: 1.5, '& .MuiBadge-badge': { backgroundColor: green[600], color: '#fff', fontSize: 11, minWidth: 18, height: 18 } }}>
                        <CheckCircleIcon sx={{ fontSize: 18, color: green[800], opacity: 0.9 }} />
                      </Badge>
                    </Tooltip>
                  )}
                  {viewers && (
                    <Tooltip title={`${viewers.join(', ')} visualizando`}>
                      <Badge badgeContent={viewers.length} max={9}
                        sx={{ ml: 1.5, '& .MuiBadge-badge': { backgroundColor: orange[600], color: '#fff', fontSize: 11, minWidth: 18, height: 18 } }}>
                        <VisibilityIcon sx={{ fontSize: 18, color: orange[800], animation: 'pulse 2s infinite' }} />
                      </Badge>
                    </Tooltip>
                  )}
                </Box>
                <Typography fontSize={14} noWrap>
                  {formatClock(problem.clock)} ({fromNowClock(problem.clock, timeEpoch)})
                </Typography>
              </Box>
              <Typography fontSize={14}>{problem.name}</Typography>
            </Box>
          )
        }
      }
    },
    {
      name: "name",
      label: "Descrição",
      options: {
        filter: false,
        sort: false,
        display: false,
      }
    },

    {
      name: "hostid",
      label: "HostId",
      options: {
        display: false,
        filter: false,
        sort: false,
      }
    },
    {
      name: "hostname",
      label: "Host",
      options: {
        filter: false,
        sort: false,
        display: false,
      }
    },
    {
      name: "ip",
      label: "IP",
      options: {
        filter: false,
        sort: false,
        display: false,
      }
    },
    {
      name: "clock",
      label: "Quando",
      options: {
        filter: false,
        sort: true,
        sortOrder: 'desc',
        display: false,
      }
    },
    {
      name: "severity",
      label: "Sev. Zabbix",
      options: {
        filter: true,
        sort: false,
        display: false,
        filterList: filterZabbixSeverity,
        customFilterListOptions: {
          render: v => {
            const labels = { 3: 'Media', 4: 'Alta', 5: 'Desastre', 6: 'API Down' }
            return `Zabbix: ${labels[v] || v}`
          }
        },
        filterOptions: {
          names: [3, 4, 5, 6],
          renderValue: v => {
            const labels = { 3: '3 - Media', 4: '4 - Alta', 5: '5 - Desastre', 6: '6 - API Down' }
            return labels[v] || v
          }
        },
      }
    },
    {
      name: "wazuh_severity",
      label: "Sev. Wazuh",
      options: {
        filter: true,
        sort: false,
        display: false,
        filterList: filterWazuhSeverity,
        customFilterListOptions: {
          render: v => {
            const labels = { 1: 'Info', 2: 'Aviso', 3: 'Media', 4: 'Alta', 5: 'Desastre' }
            return `Wazuh: ${labels[v] || v}`
          }
        },
        filterOptions: {
          names: [1, 2, 3, 4, 5],
          renderValue: v => {
            const labels = { 1: '1 - Info (4-6)', 2: '2 - Aviso (7-9)', 3: '3 - Media (10-11)', 4: '4 - Alta (12-13)', 5: '5 - Desastre (14+)' }
            return labels[v] || v
          }
        },
      }
    },
    {
      name: "acks",
      label: "Vistos",
      options: {
        filter: true,
        sort: true,
        display: false,
        filterList: filterAcks,
        customFilterListOptions: { render: v => v == 0 ? 'Nao vistados' : 'Vistados' },
        filterOptions: {
          names: [0, 1],
          renderValue: v => v == 0 ? 'Nao vistados' : 'Vistados'
        }
      }
    },
    {
      name: "action",
      label: "Action",
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          const problem = problemsRef.current[dataIndex]
          if (!problem) return null

          const codEmpresa = problem.cod_empresa
          const eventId = problem.event_id
          const acks = problem.acks

          if (problem.severity == 6 || problem.severity == 7 || problem.event_id == 0) {
            return (
              <>
                <Tooltip title={problem.tags || "Reconhecer alarme"} >
                  <IconButton disabled={!auth.hasPerm('problem.edit')} sx={{
                    backgroundColor: acks > 0 ? grey[900] : ""
                  }}
                    onClick={
                      () => {
                        setId(problem.event_id)
                        setHostid(problem.hostid)
                        setTags(problem.tags)
                        setSeverity(problem.severity)
                        setCodEmpresa(problem.cod_empresa)
                        setEventId(problem.event_id)
                        setDetailAlarms(`${problem.hostname} - ${problem.name}`)
                        setAlarmSource(problem.source || 'zabbix')
                        setAlarmHostname(problem.hostname || '')
                        setAlarmIp(problem.ip || '')
                        setAlarmClock(problem.clock || '')
                        setAlarmOccurrences(problem.occurrence_count || 1)
                        setAlarmTagsPpi(problem.tags_ppi || 0)
                        setHandlerDialog(true)
                      }
                    }
                  >
                    <Badge badgeContent={acks} color="success" >
                      {acks > 0 ?
                        <AssignmentTurnedInIcon sx={{ color: "white" }} /> :
                        <AssignmentLateIcon sx={{ color: grey[900] }} />
                      }
                    </Badge>
                  </IconButton>
                </Tooltip>
                {problem.tags_ppi > 0 ?
                  <Tooltip title="Procedimento do alarme">
                    <IconButton sx={{
                      backgroundColor: grey[900],
                      color: "white"
                    }}
                      onClick={() => {
                        setPpi(problem.tags_ppi)
                        sethandlerDialogPPI(true)
                      }}
                    >
                      <ArticleIcon />
                    </IconButton>
                  </Tooltip>
                  : ""}
                {problem.source === 'wazuh' &&
                <Tooltip title="Dispensar alarme">
                  <IconButton disabled={!auth.hasPerm('problem.edit')} sx={{ color: grey[900] }}
                    onClick={() => handleDismiss(problem.cod_empresa, problem.event_id)}
                  >
                    <HighlightOffIcon />
                  </IconButton>
                </Tooltip>}
              </>
            )
          }
          return (
            <Box sx={{ display: 'flex' }}>
              {acks > 0 ?
                <Tooltip title={problem.tags || "Reconhecer alarme"} >
                  <IconButton disabled={!auth.hasPerm('problem.edit')} sx={{
                    backgroundColor: acks > 0 ? grey[900] : grey[100],
                    color: acks > 0 ? "white" : grey[900]
                  }}
                    onClick={
                      () => {
                        setId(problem.event_id)
                        setHostid(false)
                        setTags(problem.tags)
                        setSeverity(problem.severity)
                        setCodEmpresa(problem.cod_empresa)
                        setEventId(problem.event_id)
                        setDetailAlarms(`${problem.hostname} - ${problem.name}`)
                        setAlarmSource(problem.source || 'zabbix')
                        setAlarmHostname(problem.hostname || '')
                        setAlarmIp(problem.ip || '')
                        setAlarmClock(problem.clock || '')
                        setAlarmOccurrences(problem.occurrence_count || 1)
                        setAlarmTagsPpi(problem.tags_ppi || 0)
                        setHandlerDialog(true)
                      }
                    }
                  >
                    <Badge badgeContent={acks} color="success" >
                      <AssignmentTurnedInIcon sx={{ color: "white" }} />
                    </Badge>
                  </IconButton>
                </Tooltip>
                :
                <Tooltip title={problem.tags || "Reconhecer alarme"} >
                  <IconButton disabled={!auth.hasPerm('problem.edit')} sx={{ color: grey[900] }}
                    onClick={
                      () => {
                        setTags(problem.tags)
                        setId(problem.event_id)
                        setSeverity(problem.severity)
                        setCodEmpresa(problem.cod_empresa)
                        setDetailAlarms(`${problem.hostname} - ${problem.name}`)
                        setEventId(problem.event_id)
                        setAlarmSource(problem.source || 'zabbix')
                        setAlarmHostname(problem.hostname || '')
                        setAlarmIp(problem.ip || '')
                        setAlarmClock(problem.clock || '')
                        setAlarmOccurrences(problem.occurrence_count || 1)
                        setAlarmTagsPpi(problem.tags_ppi || 0)
                        setHandlerDialog(true)
                      }
                    }
                  >
                    <AssignmentLateIcon sx={{ color: grey[900] }} />
                  </IconButton>
                </Tooltip>
              }
              {problem.source !== 'wazuh' && <>
                <Tooltip title="Histórico do alarme. (Max: 36hrs)">
                  <IconButton
                    sx={{ color: grey[900] }}
                    onClick={() => {
                      setHistoryInfo({
                        cod_empresa: problem.cod_empresa,
                        triggerid: problem.triggerid
                      })
                      setHandlerDialogHistory(true)
                    }}
                  >
                    <RotateLeftIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Grafico do Item">
                  <IconButton
                    sx={{ color: grey[900] }}
                    onClick={() => {
                      setCodEmpresa(problem.cod_empresa)
                      setItemid(problem.itemid)
                      setHandlerGraph(true)
                    }}>
                    <ShowChartIcon />
                  </IconButton>
                </Tooltip>
              </>}
              <Tooltip title="Informações da Empresa">
                <IconButton sx={{ color: grey[900] }}
                  onClick={() => {
                    const cod_empresa = problem.cod_empresa
                    api.get(`/empresa/find/cod_empresa/${cod_empresa}`).then(res => {
                      setId(res.data.id)
                      setCodEmpresa(cod_empresa)
                      setHandlerDialogEmpresa(true)
                    }).catch(err => {
                      const msg = err?.response?.status === 404
                        ? 'Empresa não cadastrada no Horus'
                        : 'Erro ao buscar empresa'
                      setDismissSnack({ open: true, message: msg, severity: 'error' })
                    })
                  }}
                >
                  <LiveHelpIcon />
                </IconButton>
              </Tooltip>
              {problem.source !== 'wazuh' &&
                <Tooltip title="Ver no Mapa">
                  <IconButton
                    sx={{ color: grey[900] }}
                    onClick={() => {
                      const cod = problem.cod_empresa
                      const hid = problem.hostid
                      api.get(`/map/find-by-host/${cod}/${hid}`).then(res => {
                        const maps = res.data
                        if (!maps || maps.length === 0) {
                          alert('Host não encontrado em nenhum mapa')
                          return
                        }
                        if (maps.length === 1) {
                          window.open(`/map?cod_empresa=${cod}&map_id=${maps[0].map_id}&hostid=${hid}`, '_blank')
                        } else {
                          setMapPickerData({ open: true, maps, cod, hid })
                        }
                      }).catch(() => alert('Erro ao buscar mapas do host'))
                    }}
                  >
                    <MapIcon />
                  </IconButton>
                </Tooltip>
              }
              {problem.tags_ppi > 0 ?
                <Tooltip title="Procedimento do alarme">
                  <IconButton sx={{
                    backgroundColor: grey[900],
                    color: "white"
                  }}
                    onClick={() => {
                      setPpi(problem.tags_ppi)
                      sethandlerDialogPPI(true)
                    }}
                  >
                    <ArticleIcon />
                  </IconButton>
                </Tooltip>
                : ""}
              {problem.source === 'wazuh' &&
              <Tooltip title="Dispensar alarme">
                <IconButton disabled={!auth.hasPerm('problem.edit')} sx={{ color: grey[900] }}
                  onClick={() => handleDismiss(problem.cod_empresa, problem.event_id)}
                >
                  <HighlightOffIcon />
                </IconButton>
              </Tooltip>}
            </Box>
          )
        },
        sort: true,
        display: true,
      }
    },
    {
      name: "tags_ppi",
      label: "PPI",
      options: {
        filter: false,
        sort: false,
        display: false,
      }
    },
  ], [filterSource, filterEmpresa, filterZabbixSeverity, filterWazuhSeverity, filterAcks, empresas, timeEpoch, auth])

  const rowsSelected = React.useMemo(() => {
    if (selectedAlarmIds.current.size === 0) return []
    return problems
      .map((p, idx) => selectedAlarmIds.current.has(`${p.cod_empresa}:${p.event_id}`) ? idx : -1)
      .filter(idx => idx !== -1)
  }, [problems])

  const options = React.useMemo(() => ({
    serverSide: true,
    count: totalCount,
    page: page,
    rowsPerPage: rowsPerPage,
    searchText: searchText,
    customToolbar: () => {
      return (<>
        <Tooltip title="Remover todos os filtros">
          <IconButton onClick={() => {
            setSearchText('')
            setFilterEmpresa([])
            setFilterSeverity([])
            setFilterAcks([])
            setFilterSource('')
            setFilterZabbixSeverity([])
            setFilterWazuhSeverity([])
            setSortColumn('clock')
            setSortDirection('desc')
            setPage(0)
            localStorage.removeItem('alarmFilters')
            getProblems(0, rowsPerPage, '', [], [], [], 'clock', 'desc', '', [], [])
          }} ><RemoveCircleOutlineIcon /></IconButton>
        </Tooltip>
        <FormControl size="small" sx={{ minWidth: 120, ml: 1 }}>
          <InputLabel id="source-filter-label">Fonte</InputLabel>
          <Select
            labelId="source-filter-label"
            value={filterSource}
            label="Fonte"
            onChange={(e) => {
              const val = e.target.value
              setFilterSource(val)
              setPage(0)
              getProblems(0, rowsPerPage, searchText, filterEmpresa, filterSeverity, filterAcks, sortColumn, sortDirection, val, filterZabbixSeverity, filterWazuhSeverity)
            }}
          >
            <SelectItem value="">Todos</SelectItem>
            <SelectItem value="zabbix">Zabbix</SelectItem>
            <SelectItem value="wazuh">Wazuh</SelectItem>
          </Select>
        </FormControl>
        {loading && <CircularProgress size={24} sx={{ ml: 1 }} />}
        {auth.hasPerm('problem.edit') && (
          <Tooltip title="Criar Ticket Avulso (Athena)">
            <IconButton onClick={openAthenaTicket} sx={{ ml: 1 }}>
              <ConfirmationNumberIcon />
            </IconButton>
          </Tooltip>
        )}
      </>
      )
    },
    onChangePage: (newPage) => {
      setPage(newPage)
      setNewAlarmIds(new Set())
      setResolvingIds(new Set())
      getProblems(newPage, rowsPerPage, searchText, filterEmpresa, filterSeverity, filterAcks, sortColumn, sortDirection, filterSource, filterZabbixSeverity, filterWazuhSeverity)
    },
    onChangeRowsPerPage: (newRowsPerPage) => {
      setRowsPerPage(newRowsPerPage)
      setPage(0)
      localStorage.setItem('Page', JSON.stringify(newRowsPerPage))
      getProblems(0, newRowsPerPage, searchText, filterEmpresa, filterSeverity, filterAcks, sortColumn, sortDirection, filterSource, filterZabbixSeverity, filterWazuhSeverity)
    },
    onSearchChange: (searchQuery) => {
      setSearchText(searchQuery || '')
      // Debounce de 300ms para evitar muitas chamadas
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current)
      }
      searchTimeoutRef.current = setTimeout(() => {
        setPage(0)
        getProblems(0, rowsPerPage, searchQuery || '', filterEmpresa, filterSeverity, filterAcks, sortColumn, sortDirection, filterSource, filterZabbixSeverity, filterWazuhSeverity)
      }, 300)
    },
    onFilterChange: (changedColumn, filterList, type) => {
      // Ignora reset automatico do MUIDataTable no mount
      if (type === 'reset') return

      // filterList e um array onde cada indice corresponde a uma coluna
      const newFilterEmpresa = filterList[1] || []
      const newFilterZabbixSev = filterList[7] || []
      const newFilterWazuhSev = filterList[8] || []
      const newFilterAcks = filterList[9] || []

      setFilterEmpresa(newFilterEmpresa)
      setFilterZabbixSeverity(newFilterZabbixSev)
      setFilterWazuhSeverity(newFilterWazuhSev)
      setFilterAcks(newFilterAcks)
      setPage(0)
      getProblems(0, rowsPerPage, searchText, newFilterEmpresa, filterSeverity, newFilterAcks, sortColumn, sortDirection, filterSource, newFilterZabbixSev, newFilterWazuhSev)
    },
    onColumnSortChange: (changedColumn, direction) => {
      const newSortDir = direction === 'asc' ? 'asc' : 'desc'
      setSortColumn(changedColumn)
      setSortDirection(newSortDir)
      setPage(0)
      getProblems(0, rowsPerPage, searchText, filterEmpresa, filterSeverity, filterAcks, changedColumn, newSortDir, filterSource, filterZabbixSeverity, filterWazuhSeverity)
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) =>
      <Tooltip title="Reconhecimento em massa">
        <IconButton
          disabled={!auth.hasPerm('problem.edit')}
          onClick={() => {
            const probs = problemsRef.current
            const eventsIds = selectedRows.data.map(row => probs[row.dataIndex].event_id)
            const details = selectedRows.data.map(row => `${probs[row.dataIndex].hostname} - ${probs[row.dataIndex].name}`)
            const empresas = selectedRows.data.map(row => probs[row.dataIndex].cod_empresa)
            const severities = selectedRows.data.map(row => probs[row.dataIndex].severity)

            if (severities.every(v => v == 6 || v == 7)) {
              alert("Não é possivel vistar em grupo alarmes de erro de Backup ou erro de API!")
              return;
            }
            if (!empresas.every(v => v == empresas[0])) {
              alert("Selecione apenas alarmes referentes a mesma empresa!")
              return;
            }
            const sources = selectedRows.data.map(row => probs[row.dataIndex].source || 'zabbix')
            const alarms = selectedRows.data.map(row => {
              const p = probs[row.dataIndex]
              return { hostname: p.hostname, ip: p.ip, name: p.name, severity: p.severity, clock: p.clock, occurrences: p.occurrences || 1, cod_empresa: p.cod_empresa }
            })
            setEventId(eventsIds)
            setDetailAlarms(details)
            setCodEmpresa(empresas[0])
            setAlarmSource(sources[0] || 'zabbix')
            setBulkAlarms(alarms)
            setHandlerDialog(true)
          }}><AssignmentLateIcon /></IconButton>
      </Tooltip>,
    filterType: 'checkbox',
    rowsPerPageOptions: [10, 30, 50, 100, 200],
    rowHover: false,
    print: false,
    download: true,
    searchAlwaysOpen: true,
    setRowProps: (row, dataIndex) => {
      const problem = problemsRef.current[dataIndex]
      const alarmId = problem ? `${problem.cod_empresa}:${problem.event_id}` : null

      // Verifica se e novo ou resolvendo (via refs)
      const isNew = alarmId && newAlarmIdsRef.current.has(alarmId)
      const isResolving = alarmId && resolvingIdsRef.current.has(alarmId)

      // Cor base por severidade
      let bgColor
      const sev = problem ? problem.severity : row[7]
      switch (sev) {
        case 7:
          bgColor = theme.palette.mode == 'dark' ? pink[300] : pink[200]
          break
        case 5:
        case 6:
          bgColor = theme.palette.mode == 'dark' ? red[400] : red[300]
          break
        case 4:
          bgColor = theme.palette.mode == 'dark' ? orange[300] : orange[200]
          break
        case 3:
          bgColor = theme.palette.mode == 'dark' ? lime[300] : lime[200]
          break
        case 2:
          bgColor = theme.palette.mode == 'dark' ? lightBlue[300] : lightBlue[200]
          break
        case 1:
          bgColor = theme.palette.mode == 'dark' ? blueGrey[300] : blueGrey[200]
          break
        default:
          bgColor = undefined
      }

      // Estilo com animacao
      const style = {
        backgroundColor: bgColor,
        transition: 'all 0.3s ease-in-out',
      }

      // Animacao de entrada (novo) - borda laranja estatica (sem glow pesado)
      if (isNew) {
        style.animation = 'fadeIn 0.5s ease-out'
        style.borderLeft = '4px solid #ff9800'
      }

      // Animacao de saida (resolvendo) - verde por 2s, depois some suave
      if (isResolving) {
        style.animation = 'fadeOut 2s ease-out forwards'
        style.backgroundColor = green[400]
      }

      // Efeito visual quando outro operador esta visualizando
      const isBeingViewed = alarmId && viewingMapRef.current[alarmId]
      if (isBeingViewed) {
        style.opacity = 0.75
        style.borderLeft = `3px solid ${orange[600]}`
      }

      return { style }
    },
    rowsSelected: rowsSelected,
    onTableChange: (action, tableState) => {
      if (action === 'rowSelectionChange') {
        const ids = new Set(
          tableState.selectedRows.data.map(row => {
            const p = problemsRef.current[row.dataIndex]
            return p ? `${p.cod_empresa}:${p.event_id}` : null
          }).filter(Boolean)
        )
        selectedAlarmIds.current = ids
      }
    },
  }), [totalCount, page, rowsPerPage, searchText, rowsSelected, filterEmpresa, filterSeverity, filterAcks, filterSource, filterZabbixSeverity, filterWazuhSeverity, sortColumn, sortDirection, loading, auth, getProblems])

  // Funcao de refresh estavel (sem dependencias que mudam)
  const refreshData = React.useCallback(() => {
    if (selectedAlarmIds.current.size > 0) return
    getProblems(page, rowsPerPage, searchText, filterEmpresa, filterSeverity, filterAcks, sortColumn, sortDirection, filterSource, filterZabbixSeverity, filterWazuhSeverity)
  }, [page, rowsPerPage, searchText, filterEmpresa, filterSeverity, filterAcks, sortColumn, sortDirection, filterSource, filterZabbixSeverity, filterWazuhSeverity, getProblems])

  // Auto-refresh a cada 60s + incrementa timeEpoch para invalidar cache fromNow
  React.useEffect(() => {
    const interval = setInterval(() => {
      setTimeEpoch(e => e + 1)
      // Phase 7: pula refresh se WebSocket entregou dados nos ultimos 60s
      const elapsed = Date.now() - lastWsUpdate.current
      if (elapsed < 60000) return
      refreshData()
    }, 60 * 1000)
    return () => clearInterval(interval)
  }, [refreshData])

  // Escuta evento do WebSocket para refresh imediato
  React.useEffect(() => {
    const handleRefresh = () => {
      if (selectedAlarmIds.current.size === 0) {
        refreshData()
      }
    }
    window.addEventListener('alarms-refresh', handleRefresh)
    return () => window.removeEventListener('alarms-refresh', handleRefresh)
  }, [refreshData])

  // Escuta novos alarmes do WebSocket e faz merge em tempo real
  // Phase 6: listener registrado uma vez, le filtros de filtersRef
  React.useEffect(() => {
    const handleNewAlarms = (event) => {
      if (selectedAlarmIds.current.size > 0) return
      const f = filtersRef.current
      if (f.page !== 0) return

      const newAlarms = event.detail
      if (!newAlarms || !Array.isArray(newAlarms) || newAlarms.length === 0) return

      const matchesFilters = (alarm) => {
        // API Down (sev=6) nao entra na tabela principal — fica no banner ApiDownBanner
        if (Number(alarm.severity) === 6) return false
        if (f.filterSource && (alarm.source || 'zabbix') !== f.filterSource) return false
        if (f.filterEmpresa.length > 0 && !f.filterEmpresa.includes(alarm.cod_empresa)) return false
        if (f.filterSeverity.length > 0 && !f.filterSeverity.includes(alarm.severity)) return false
        if (f.filterZabbixSeverity.length > 0 && (alarm.source || 'zabbix') === 'zabbix') {
          if (!f.filterZabbixSeverity.includes(alarm.severity)) return false
        }
        if (f.filterWazuhSeverity.length > 0 && (alarm.source || 'zabbix') === 'wazuh') {
          if (!f.filterWazuhSeverity.includes(alarm.severity)) return false
        }
        if (f.filterAcks.length > 0) {
          const hasAck = alarm.acks > 0
          const wantNoAck = f.filterAcks.includes(0)
          const wantAck = f.filterAcks.some(a => a > 0)
          if (wantNoAck && hasAck) return false
          if (wantAck && !hasAck) return false
        }
        if (f.searchText) {
          const search = f.searchText.toLowerCase()
          const name = String(alarm.name || '').toLowerCase()
          const hostname = String(alarm.hostname || '').toLowerCase()
          const ip = String(alarm.ip || '').toLowerCase()
          const cod = String(alarm.cod_empresa || '').toLowerCase()
          if (!name.includes(search) && !hostname.includes(search) && !ip.includes(search) && !cod.includes(search)) {
            return false
          }
        }
        return true
      }

      const filteredNew = newAlarms.filter(matchesFilters)
      if (filteredNew.length === 0) return

      lastWsUpdate.current = Date.now()

      const newIds = filteredNew.map(a => `${a.cod_empresa}:${a.event_id}`)

      // Phase 2: batch all state updates into a single render
      unstable_batchedUpdates(() => {
        // Phase 5: cap animacao em MAX_ANIMATION_IDS
        setNewAlarmIds(prev => {
          const merged = new Set([...prev, ...newIds])
          if (merged.size > MAX_ANIMATION_IDS) return new Set(newIds.slice(0, MAX_ANIMATION_IDS))
          return merged
        })

        setProblems(prev => {
          const existingHashes = new Set(prev.map(p => `${p.cod_empresa}:${p.event_id}`))
          const uniqueNew = filteredNew.filter(a => !existingHashes.has(`${a.cod_empresa}:${a.event_id}`))
          if (uniqueNew.length === 0) return prev

          // API Down (sev=6) ja foi filtrado em matchesFilters — agora vivem no ApiDownBanner
          let merged = [...uniqueNew, ...prev]
          const clockSortFn = f.sortDirection === 'desc'
            ? (a, b) => new Date(b.clock) - new Date(a.clock)
            : (a, b) => new Date(a.clock) - new Date(b.clock)
          merged.sort(clockSortFn)

          // Phase 8: conta apenas alarmes que realmente entraram (dedup)
          setTotalCount(pc => pc + uniqueNew.length)

          return merged.slice(0, f.rowsPerPage)
        })
      })

      // Phase 5: timer unico para limpeza de animacoes
      if (animationTimerRef.current) clearTimeout(animationTimerRef.current)
      animationTimerRef.current = setTimeout(() => {
        setNewAlarmIds(prev => {
          const updated = new Set(prev)
          newIds.forEach(id => updated.delete(id))
          return updated
        })
      }, 10000)
    }

    window.addEventListener('alarms-new', handleNewAlarms)
    return () => window.removeEventListener('alarms-new', handleNewAlarms)
  }, [])

  // Escuta alarmes removidos do WebSocket
  React.useEffect(() => {
    const handleRemovedAlarms = (event) => {
      const removed = event.detail
      if (!removed || !Array.isArray(removed) || removed.length === 0) return

      lastWsUpdate.current = Date.now()

      const removedIds = removed.map(a => `${a.cod_empresa}:${a.event_id}`)
      setResolvingIds(new Set(removedIds))

      setTimeout(() => {
        unstable_batchedUpdates(() => {
          setProblems(prev => {
            const removedSet = new Set(removedIds)
            return prev.filter(p => !removedSet.has(`${p.cod_empresa}:${p.event_id}`))
          })
          setResolvingIds(new Set())
          setTotalCount(prev => Math.max(0, prev - removed.length))
        })
      }, 2000)
    }

    window.addEventListener('alarms-removed', handleRemovedAlarms)
    return () => window.removeEventListener('alarms-removed', handleRemovedAlarms)
  }, [])

  // Phase 6: ref estavel para getProblems no listener de ack
  const getProblemsRef = React.useRef(getProblems)
  React.useEffect(() => { getProblemsRef.current = getProblems }, [getProblems])

  // Escuta ack_update do WebSocket para atualizar badge em tempo real
  React.useEffect(() => {
    const handleAckUpdate = (event) => {
      const { cod_empresa, event_ids } = event.detail
      if (!cod_empresa || !event_ids) return

      lastWsUpdate.current = Date.now()

      const eidSet = new Set(event_ids.map(Number))
      unstable_batchedUpdates(() => {
        setProblems(prev => {
          const updated = prev.map(p => {
            if (Number(p.cod_empresa) === Number(cod_empresa) && eidSet.has(Number(p.event_id))) {
              return { ...p, acks: (p.acks || 0) + 1 }
            }
            return p
          })
          const f = filtersRef.current
          if (f.filterAcks.length > 0 && f.filterAcks.includes(0) && !f.filterAcks.some(a => a > 0)) {
            const filtered = updated.filter(p => !eidSet.has(Number(p.event_id)) || Number(p.cod_empresa) !== Number(cod_empresa))
            const removedCount = updated.length - filtered.length
            if (removedCount > 0) {
              setTotalCount(pc => pc - removedCount)
              setTimeout(() => getProblemsRef.current(), 300)
            }
            return filtered
          }
          return updated
        })
      })
    }

    window.addEventListener('ack-update', handleAckUpdate)
    return () => window.removeEventListener('ack-update', handleAckUpdate)
  }, [])

  // Escuta field_update (escalation_count, ppi_execution_count) do WebSocket
  React.useEffect(() => {
    const handleFieldUpdate = (event) => {
      const { cod_empresa, event_id, field, value } = event.detail
      if (!cod_empresa || !event_id || !field) return
      setProblems(prev => prev.map(p => {
        if (Number(p.cod_empresa) === Number(cod_empresa) && Number(p.event_id) === Number(event_id)) {
          return { ...p, [field]: value }
        }
        return p
      }))
    }
    window.addEventListener('alarm-field-update', handleFieldUpdate)
    return () => window.removeEventListener('alarm-field-update', handleFieldUpdate)
  }, [])

  // Escuta viewing_start/stop do WebSocket
  React.useEffect(() => {
    const handleViewing = (event) => {
      const { type, cod_empresa, event_id, user_name } = event.detail
      if (!cod_empresa || !event_id || !user_name) return
      const key = `${cod_empresa}:${event_id}`
      setViewingMap(prev => {
        const viewers = prev[key] ? [...prev[key]] : []
        if (type === 'viewing_start') {
          if (!viewers.includes(user_name)) viewers.push(user_name)
        } else if (type === 'viewing_stop') {
          const idx = viewers.indexOf(user_name)
          if (idx !== -1) viewers.splice(idx, 1)
        }
        if (viewers.length === 0) {
          const { [key]: _, ...rest } = prev
          return rest
        }
        return { ...prev, [key]: viewers }
      })
    }
    window.addEventListener('viewing-update', handleViewing)
    return () => window.removeEventListener('viewing-update', handleViewing)
  }, [])

  // Titulo dinamico da pagina (browser tab)
  React.useEffect(() => {
    const baseTitle = 'Horus'
    if (totalCount > 0) {
      document.title = `(${totalCount}) Alarmes - ${baseTitle}`
    } else {
      document.title = `Alarmes - ${baseTitle}`
    }
    // Restaura titulo original ao sair
    return () => { document.title = baseTitle }
  }, [totalCount])

  // Carrega inicial (com filtros salvos)
  React.useEffect(() => {
    getProblems(0, rowsPerPage, searchText, filterEmpresa, filterSeverity, filterAcks, sortColumn, sortDirection, filterSource, filterZabbixSeverity, filterWazuhSeverity)
    getEmpresas()
  }, [])

  // Refresh apos criar ack
  React.useEffect(() => {
    if (update) {
      getProblems(page, rowsPerPage, searchText, filterEmpresa, filterSeverity, filterAcks, sortColumn, sortDirection, filterSource, filterZabbixSeverity, filterWazuhSeverity)
      setUpdate(false)
    }
  }, [update, page, rowsPerPage, searchText, filterEmpresa, filterSeverity, filterAcks, sortColumn, sortDirection, filterSource, filterZabbixSeverity, filterWazuhSeverity, getProblems])

  return (
    <NotifyOptionsProvider problems={{ problems }}>
      <Container maxWidth={false} sx={{ mt: 4, mb: 4, height: 'auto' }}>
        <FormDialog open={handlerDialog} codEmpresa={codEmpresa} tags={tags} eventId={eventId} hostid={hostid} severity={severity} detailAlarms={detailAlarms} source={alarmSource} hostname={alarmHostname} ip={alarmIp} clock={alarmClock} occurrenceCount={alarmOccurrences} tagsPpi={alarmTagsPpi} bulkAlarms={bulkAlarms} handlerClose={() => {
          setHandlerDialog(false)
          setUpdate(true)
        }} />
        <GraphDialog open={handlerGraph} codEmpresa={codEmpresa} itemid={itemid} handlerClose={() => {
          setHandlerGraph(false)
        }} />
        <FormDialogHistory open={handlerDialogHistory} info={historyInfo} handlerClose={() => {
          setHandlerDialogHistory(false)
        }} />
        <FormDialogEmpresa open={handlerDialogEmpresa} codEmpresa={codEmpresa} id={id} handlerClose={() => setHandlerDialogEmpresa(false)} />
        <FormDialogPPI open={handlerDialogPPI} id={ppi} handlerClose={() => {
          sethandlerDialogPPI(false)
        }} />
        <Dialog open={mapPickerData.open} onClose={() => setMapPickerData({ open: false, maps: [], cod: null, hid: null })}>
          <DialogTitle>Selecione o mapa</DialogTitle>
          <List sx={{ minWidth: 300 }}>
            {mapPickerData.maps.map((m) => (
              <ListItemButton key={m.map_id} onClick={() => {
                window.open(`/map?cod_empresa=${mapPickerData.cod}&map_id=${m.map_id}&hostid=${mapPickerData.hid}`, '_blank')
                setMapPickerData({ open: false, maps: [], cod: null, hid: null })
              }}>
                <ListItemText primary={m.name} secondary={`Mapa ${m.map_id}`} />
              </ListItemButton>
            ))}
          </List>
        </Dialog>
        <Snackbar
          open={athenaSnack.open}
          autoHideDuration={4000}
          onClose={() => setAthenaSnack({ ...athenaSnack, open: false })}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert severity={athenaSnack.severity} onClose={() => setAthenaSnack({ ...athenaSnack, open: false })}>
            {athenaSnack.message}
          </Alert>
        </Snackbar>
        <Snackbar
          open={dismissSnack.open}
          autoHideDuration={3000}
          onClose={() => setDismissSnack({ ...dismissSnack, open: false })}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert severity={dismissSnack.severity} onClose={() => setDismissSnack({ ...dismissSnack, open: false })}>
            {dismissSnack.message}
          </Alert>
        </Snackbar>
        <Dialog open={athenaTicketOpen} onClose={() => setAthenaTicketOpen(false)} fullWidth maxWidth="sm">
          <DialogTitle>Criar Ticket Avulso - Athena</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              required
              margin="dense"
              label="Assunto"
              fullWidth
              variant="outlined"
              size="small"
              value={athenaTicket.subject}
              onChange={(e) => setAthenaTicket({ ...athenaTicket, subject: e.target.value })}
            />
            <TextField
              required
              margin="dense"
              label="Descricao"
              fullWidth
              variant="outlined"
              size="small"
              multiline
              rows={4}
              value={athenaTicket.description}
              onChange={(e) => setAthenaTicket({ ...athenaTicket, description: e.target.value })}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setAthenaTicketOpen(false)}>Cancelar</Button>
            <Button onClick={submitAthenaTicket} disabled={athenaLoading || !athenaTicket.subject || !athenaTicket.description}>
              {athenaLoading ? 'Enviando...' : 'Criar Ticket'}
            </Button>
          </DialogActions>
        </Dialog>
        <ThemeProvider theme={theme}>
          <ApiDownBanner onAck={openAckDialog} />
          <Box sm={12} lg={12}>
            <MUIDataTable
              title={"Alarmes"}
              data={problems}
              columns={columns}
              options={options}
            />
          </Box>
        </ThemeProvider>
      </Container>
      {showPerf && <PerfOverlay renderCount={renderCountRef.current} />}
    </NotifyOptionsProvider>
  )
}
